var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,23.5L12.5,23.5c-0.2,0-0.4-0.1-0.6-0.3L9,20.3c-0.1-0.1-0.2-0.3-0.2-0.5s0-0.5,0.2-0.6 c0.1-0.2,0.3-0.3,0.6-0.3s0.5,0.1,0.7,0.3l1.5,1.5v-7.3H4.4l1.5,1.5c0,0,0,0,0.1,0.1c0.2,0.2,0.2,0.4,0.2,0.6S6.1,16,5.9,16.2 s-0.4,0.2-0.6,0.2s-0.4-0.1-0.6-0.3l-2.9-2.9c-0.3-0.3-0.3-0.9,0-1.2l2.9-2.9C4.8,9,5,8.9,5.2,8.8c0.3,0,0.5,0.1,0.7,0.3 s0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.3,0.6l-1.4,1.3h7.3V4.3l-1.5,1.5c0,0,0,0-0.1,0.1C9.9,6.1,9.7,6.1,9.5,6.1S9.1,6,8.9,5.8 C8.7,5.6,8.7,5.4,8.7,5.2S8.8,4.8,9,4.6l2.9-2.9c0.1-0.1,0.3-0.2,0.5-0.2l0,0c0.3,0,0.5,0.1,0.7,0.2L16,4.6c0,0,0,0,0.1,0.1 c0.3,0.4,0.3,0.9-0.1,1.2s-0.9,0.3-1.2-0.1l-1.4-1.4v7.3h7.3l-1.5-1.5C19.1,10.1,19,9.9,19,9.7s0-0.4,0.2-0.6 c0.1-0.2,0.3-0.3,0.6-0.3c0.3,0,0.5,0.1,0.7,0.3l2.9,2.9c0.3,0.3,0.3,0.9,0,1.2l-2.9,2.9c0,0,0,0-0.1,0.1c-0.2,0.2-0.4,0.2-0.6,0.2 s-0.4-0.1-0.6-0.3S19,15.7,19,15.5s0.1-0.4,0.3-0.6l1.4-1.4h-7.3v7.3l1.5-1.5c0,0,0,0,0.1-0.1c0.2-0.2,0.4-0.2,0.6-0.2 c0.2,0,0.4,0.1,0.6,0.3c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.3,0.6l-2.9,2.9C12.9,23.4,12.7,23.5,12.5,23.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.e6354c605415fe078360476ebb46ad3a.svg";
export { ForwardRef as ReactComponent };